<header class="home-navbar" [class.is-open]="isMenuOpen()">
  <div class="header-content">
    <div class="menu-toggle">
      <button mat-icon-button (click)="menuStateService.toggleMenu()">
        @if (!isMenuOpen()) {
          <i class="fa-solid fa-bars menu-icon"></i>
        } @else {
          <i class="fa-solid fa-close"></i>
        }
      </button>
      @if (isMenuOpen()) {
        <span>Close</span>
      }
    </div>
    <div class="logo-header">
      <a href="/home" class="ntt-logo" title="Return to Homepage">
        <img src="../../../assets/images/new_logo_white.svg" alt="NTT Data Logo" />
        <div class="div-title">
          <span>Performance</span>
          <span>Platform Portal</span>
        </div>
      </a>
    </div>
    <div class="header-details">
      <!-- Service Center -->
      <!-- <button
        class="select-items service-center"
        mat-button
        [disableRipple]="true"
        [matMenuTriggerFor]="menuServiceCenter"
        type="button"
      >
        <div class="task-button">
          <img [src]="serviceCenterIcon()" alt="List check"/>
        </div>
      </button>

      <mat-menu #menuServiceCenter="matMenu">
        <div class="service-notifications-menu">
          @if (openTasks() > 0) {
            <div class="tasks-message">
              <span>
                You have <b (click)="redirectTo('/requests-management')">{{ openTasks() }} open tasks</b> created by you
              </span>
            </div>
          } @else {
            <div class="empty-message">
              <img src="assets/images/icons/homepage/header/empty_tasks.svg" alt="Empty Tasks Icon" />
              <span>We'll let you know when we get news for you.</span>
            </div>
          }
          <div class="view-link">
            <i class="fa-solid fa-eye"></i>
            <a [routerLink]="['/requests-management']" target="_blank">view request management</a>
          </div>
        </div>
      </mat-menu> -->

      <!-- Notifications -->
      <button
        class="select-items notifications"
        mat-button
        [disableRipple]="true"
        [matMenuTriggerFor]="menuNotifications"
        type="button"
      >
        <div class="notification-button">
          <i class="fa-solid fa-bell"></i>
          @if (unreadNotificationsCount() > 0) {
            <span class="notification-badge"></span>
          }
        </div>
      </button>

      <mat-menu #menuNotifications="matMenu">
        <div class="service-notifications-menu">
          <div class="title-container">
            <div>
              <span class="title">My Notifications</span>
              <span class="count">{{ unreadNotificationsCount() }}</span>
            </div>
            <div class="mark-all-read" [class.active]="unreadNotificationsCount() > 0" (click)="$event.stopPropagation(); markAllAsRead()">
              <span>Mark all as read</span>
            </div>
          </div>
          @if (unreadNotificationsCount() > 0) {
            <div class="notifications-message">
              @for (notification of notifications(); track notification.notificationRecipientsId; let i = $index) {
                @if (shouldShowDivisor(i)) {
                  <div class="divisor notifications"></div>
                }
                <div class="message-container" (click)="$event.stopPropagation()">
                  <img
                  [src]="
                    notification.documentSource === 'Task Management'
                    ? 'assets/images/icons/notifications/task_management_notification.svg'
                    : 'assets/images/icons/notifications/conversation_notification.svg'
                    "
                  [alt]="notification.title"
                  />
                <div class="informations">
                  <div class="header">
                    <div>
                      <span class="title" (click)="$event.stopPropagation()">{{ notification.title }}</span>
                      <i class="circle-divisor"></i>
                      <span class="date" (click)="$event.stopPropagation()">{{ notification.creationDate ? formatDate(notification.creationDate.toString()) : '' }}</span>
                    </div>
                    <i class="fa-solid fa-up-right-from-square link" (click)="$event.stopPropagation(); redirectTo(notification.path, notification.notificationRecipientsId)"></i>
                  </div>
                  <div class="description">
                    <div [innerHTML]="processNotificationMessage(notification.message)" (click)="onTaskIdClick($event, notification)"></div>
                  </div>
                  <span class="source-pill">{{ SourceSystemEnum[notification.sourceSystem] }}</span>
                </div>
              </div>
              }
            </div>
          } @else {
            <div class="empty-message">
              <img src="assets/images/icons/homepage/header/empty_notifications.svg" alt="Empty Notifications Icon" />
              <span>We'll let you know when we get news for you.</span>
            </div>
          }
          <div class="view-link" (click)="$event.stopPropagation()">
            <i class="fa-solid fa-eye"></i>
            <a [routerLink]="['/my-workspace/notifications-center']" target="_blank">view notifications history</a>
          </div>
        </div>
      </mat-menu>

      <div class="vertical-divisor"></div>

      <!-- User Profile -->
      <button
        class="select-items user-informations"
        mat-button
        [disableRipple]="true"
        [matMenuTriggerFor]="menuUserProfile"
        type="button"
      >
        <div class="profile-button">
          <img src="assets/images/icons/homepage/header/user_profile.svg" alt="User Profile Icon" />
          <span>{{ userInfo().name }}</span>
          <img src="assets/images/icons/chevron-down.svg" alt="Arrow down" />
        </div>
      </button>

      <mat-menu #menuUserProfile="matMenu">
        <div class="user-profile-menu">
          <div class="user-details">
            <div class="avatar-wrapper">
              <app-avatar [name]="userInfo().name!" [size]="'sm'"></app-avatar>
            </div>
            <span class="username">{{ userInfo().name }}</span>
            <span class="email">{{ userInfo().email }}</span>
          </div>
          <div class="divisor dashed"></div>
          <div class="header-menu-items">
            @for (item of headerMenuItems(); track $index) {
              <div class="header-menu-item" (click)="redirectTo(item.link!)">
                <i class="{{ item.icon }}"></i>
                <span>{{ item.title }}</span>
              </div>
            }
          </div>
          <div class="divisor solid"></div>
          <div class="header-menu-item">
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
            <span class="logout" (click)="logout()">Log out</span>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
</header>
